import React from 'react';

import CameraIcon from '@mui/icons-material/Camera';
import HistoryIcon from '@mui/icons-material/History';
import { Box, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import GroupList from './GroupList';
import PurchaseHistory from './PurchaseHistory';
import { nurseryIdSelector, apiSettingsSelector } from './selector';
import { refreshApiSettings } from './thunk';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import Title from '@/components/Title';

/** プロパティ */
export type Props = {
  /** 子ども */
  child: ChildJson,
}

const Photos: React.FC<Props> = ({
  child,
}) => {
  const dispatch = useDispatch();
  const nurseryId = useSelector(nurseryIdSelector);
  const apiSettings = useSelector(apiSettingsSelector);
  const [tabIndex, setTabIndex] = React.useState(0);
  React.useEffect(() => {
    let isUpdate = false;
    if (apiSettings === null) {
      isUpdate = true;
    } else {
      const keys = Object.keys(apiSettings);
      if (keys.length > 0) {
        isUpdate = keys[0] !== nurseryId;
      }
    }
    if (isUpdate) {
      dispatch(refreshApiSettings({ nurseryId }));
    }
  }, [dispatch, nurseryId, apiSettings]);
  const tabs = [{
    label: '写真販売',
    icon: <CameraIcon />,
  }, {
    label: '購入写真・履歴',
    icon: <HistoryIcon />,
  }];
  return (
    <div>
      <Title title={`写真販売（${child.name}）`} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '10px' }}>
        <Tabs
          value={tabIndex}
          variant="scrollable"
          scrollButtons="auto"
          onChange={(_event: React.SyntheticEvent, index: number) => {
            setTabIndex(index);
          }}
        >
          {tabs.map((item) => (
            <Tab
              label={item.label}
              key={item.label}
              icon={item.icon}
              iconPosition="start"
            />
          ))}
        </Tabs>
      </Box>
      {tabIndex === 0 && (
        <GroupList child={child} />
      )}
      {tabIndex === 1 && (
        <PurchaseHistory child={child} />
      )}
    </div>
  );
};

export default Photos;
